import MyContainer from "@/components/MyContainer";
import DeliveryFeeForm from "@/pages/delivery-fee/form/delivery-fee-form";

export function CreateDeliveryFee() {
  return (
    <MyContainer
      title="Create Delivery Fee"
      subtitle="Create a new delivery fee option"
    >
      <DeliveryFeeForm mode="create" />
    </MyContainer>
  );
}
